<template>
<div>
  <top-header></top-header>
	<main-menu></main-menu>
    <div class="pagecontainer  container">
     <div class="heading" ><span><b>Admin Corporate</b></span></div>
    </div>

	 	<bottom-footer></bottom-footer>
</div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import Employee from '@/components/Employee.vue'

export default {
  components: { MainMenu,
    TopHeader,
    Employee,
    BottomFooter
  }
}
</script>
<style scoped>

</style>
